<p-dialog
  [visible]="visible()"
  (visibleChange)="handleVisibilityChange($event)"
  [modal]="true"
  styleClass="w-[35rem]"
  contentStyleClass="flex flex-col gap-2"
>
  <ng-template pTemplate="header">
    <h5>Important: Secure Your Session</h5>
  </ng-template>

  <ng-template pTemplate="content"
    ><p class="body-1-regular text-grey-7">
      You may be logged in from a computer that might be shared among multiple
      users in the clinic. To protect patient data and your privacy, we
      recommend enabling automatic logout for this session. This will happen
      automatically if you clock-in, or if you close the tab.
    </p>
    <div class="flex items-center">
      <p-checkbox
        id="dontAskLaterCheckbox"
        inputId="dontAskLater"
        label="Don't ask me later"
        labelStyleClass="text-navy pt-0.5"
        [binary]="true"
        [(ngModel)]="dontAskLater"
      />
    </div>
  </ng-template>

  <ng-template pTemplate="footer">
    <div class="flex justify-end">
      <p-button
        size="small"
        label="No thanks, I'll log out manually"
        [outlined]="true"
        (onClick)="handleVisibilityChange(false)"
      ></p-button>
      <p-button
        size="small"
        label="Enable Automatic Log Out"
        (onClick)="enableAutoLogOut()"
      ></p-button>
    </div>
  </ng-template>
</p-dialog>
